module.exports = __webpack_public_path__ + "static/media/rm-min.455befd7.png";